var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile__overlays"},[_c('div',{staticClass:"tile__stoppers stoppers"},[_c('span',{staticClass:"stoppers__stopper"},[_vm._v(_vm._s(_vm.stopper))])])])}
var staticRenderFns = []

export { render, staticRenderFns }